import type { StateCreator } from 'zustand';

import { createCharacterSlice } from './characterSlice';
import { createGenerationSlice } from './generationSlice';
import { createLibrarySlice } from './librarySlice';
import type { IWardrobeStore } from './types';
import { createUiSlice } from './uiSlice';
import { createWardrobeSlice } from './wardrobeSlice';

/**
 * The wardrobe store is composed from five slice modules. Each slice owns its
 * own initial state + the actions that primarily mutate that slice; cross-
 * slice writes are documented in each slice's file header.
 *
 * Library + wardrobe items are NOT pre-loaded at module level — they're
 * fetched on login via `loadUserLibrary()` (defined in librarySlice).
 */
const useWardrobeStore: StateCreator<IWardrobeStore> = (set, get, api) => ({
  ...createUiSlice(set, get, api),
  ...createCharacterSlice(set, get, api),
  ...createWardrobeSlice(set, get, api),
  ...createGenerationSlice(set, get, api),
  ...createLibrarySlice(set, get, api),
});

export default useWardrobeStore;
